import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'templateSelect',
    'contentInput',
    'titleInput',
    'otherInputWrapper',
  ];

  static values = {
    templatesUrl: String
  }

  connect() {
    if (this.hasTemplateSelectTarget) {
      this.loadTemplateContentBound = this.loadTemplateContent.bind(this);
      $(this.templateSelectTarget).on('select2:select', this.loadTemplateContentBound);
    }

    this.toggleOtherInput();
  }

  disconnect() {
    // prevent double calls because connect is called twice
    if (this.hasTemplateSelectTarget) {
      $(this.templateSelectTarget).off('select2:select', this.loadTemplateContentBound);
    }
  }

  loadTemplateContent() {
    $(this.templateSelectTarget).prop('disabled', true);

    const params = new URLSearchParams({ template: this.templateSelectTarget.value });

    fetch(`${this.templatesUrlValue}&${params}`, {
      headers: { 'Accept': 'application/json' },
    })
      .then(response => {
        if (!response.ok) {
          return {};
        } else {
          return response.json();
        }
      })
      .then(data => {
        this.handleContentInput(data.content);
        this.handleTitleInput(data.title);
        $(this.templateSelectTarget).prop('disabled', false);
      });
  }

  toggleOtherInput() {
    const checkbox = this.element.querySelector('#answer_notifier_other');
    if (!checkbox) return;
    if (checkbox.checked) {
      this.otherInputWrapperTarget.style.display = 'block';
    } else {
      this.otherInputWrapperTarget.style.display = 'none';
      const input = this.otherInputWrapperTarget.querySelector('input');
      if (input) input.value = '';
    }
  }

  handleContentInput(newContent) {
    // Find editor that is used inside this controller
    // (in case there are multiple editors on the page, e.g. in other controllers)
    const editor = tinymce.editors.find(e =>
      this.element.contains(
        e.getElement() // get original textarea that TinyMCE was initialized on
      )
    );

    if (editor) {
      editor.setContent(newContent ?? '');
      editor.save(); // apply changes to hidden textarea
    } else {
      this.contentInputTarget.value = newContent;
    }
  }

  handleTitleInput(newTitle) {
    if (!this.hasTitleInputTarget) {
      return;
    }

    if (newTitle) {
      this.titleInputTarget.value = newTitle;
    } else {
      this.titleInputTarget.value = '';
    }
  }
}
